import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
    faBookMedical,
    faBriefcaseMedical,
    faLaptopMedical,
    faMapMarkerAlt,
    faNotesMedical,
    faTooth,
    faUserNurse,
} from '@fortawesome/pro-solid-svg-icons';
import { faStethoscope } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { WarningService } from '@app/core/services/warning/warning.service';
import { ItineraryActions } from '@app/core/ngrx/actions';
import { Store } from '@ngrx/store';
import { State } from '@app/core/ngrx/reducers';
import { itinerarySelectors, userSelectors } from '@app/core/ngrx/selectors';
import { ProgramService } from '@app/core/services/program/program.service';
import { ApplicationService } from '@app/core/services/application/application.service';
import { IonSelect } from '@ionic/angular';
import { SendEventActionsService } from '@app/core/services/events/sendEventActions.service';
import { NavController } from '@ionic/angular';

@Component({
    selector: 'app-itinerary-create-items-mobile',
    templateUrl: './itinerary-create-items-mobile.component.html',
    styleUrls: ['./itinerary-create-items-mobile.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule, FontAwesomeModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]})
export class ItineraryCreateItemsMobileComponent implements OnChanges {
    @Input() itineraryItem: any;
    @Input() index: any;

    @ViewChild(IonSelect) select: IonSelect;
    rows: any[] = [];

    USER_ID: string;
    USER_ID$ = this.store.select(userSelectors.getUserID);

    faNotesMedical = faNotesMedical;
    faMapMarkerAlt = faMapMarkerAlt;
    faStethoscope = faStethoscope;
    faBookMedical = faBookMedical;
    faBriefcaseMedical = faBriefcaseMedical;
    faLaptopMedical = faLaptopMedical;
    faTooth = faTooth;
    faUserNurse = faUserNurse;

    iconOfiti: any;

    itinerarySelections: any[] = [];

    customAlertOptions: any = {
        cssClass: 'time-selection',
    };

    savedItem: any = {};

    constructor(
        private warning: WarningService,
        private store: Store<State>,
        private programService: ProgramService,
        private applicationService: ApplicationService,
        private sendEventActionsService: SendEventActionsService,
        private navCtrl: NavController
    ) {}

    ngOnChanges() {
        this.store
            .select(itinerarySelectors.getItineraryList)
            .subscribe((itineraryList: any) => {
                this.itinerarySelections = itineraryList.map(
                    (itineraryItem: any) => {
                        return { ...itineraryItem };
                    }
                );
            });
        this.setIcons();

        this.USER_ID$.subscribe((userid: string) => (this.USER_ID = userid));
    }

    setIcons(): void {
        switch (this.itineraryItem.type) {
            case 'Hands-On':
                this.iconOfiti = faStethoscope;
                break;
            case 'Observership':
                this.iconOfiti = faNotesMedical;
                break;
            case 'Nursing':
                this.iconOfiti = faUserNurse;
                break;
            case 'Dentistry':
                this.iconOfiti = faTooth;
                break;
            case 'Virtual':
                this.iconOfiti = faLaptopMedical;
                break;
            case 'Virtual Pre-med shadowing':
                this.iconOfiti = faLaptopMedical;
                break;
            case 'Research':
                this.iconOfiti = faBookMedical;
                break;
            case 'Pre-med shadowing':
                this.iconOfiti = faBriefcaseMedical;
                break;
            default:
                this.iconOfiti = faNotesMedical;
                break;
        }
    }

    action() {
        alert('sup');
    }

    removeFromItinerary() {
        this.warning
            .confirmationPrompt({
                header: 'Remove Program',
                cssClass: 'user-warning',
                message:
                    'Are you sure you want to remove this program from your Itinerary?',
                dismissText: 'Cancel',
                confirmationText: 'Remove Now.',
            })
            .then((confirm: any) => {
                if (confirm) {
                    // this.goToProfileBlock();
                } else {
                    // get current list from local storage
                    let itineraryListString = localStorage.getItem(
                        this.USER_ID + '-itinerarySelections'
                    );

                    let currentItineraryList = JSON.parse(itineraryListString);
                    // filter out all itinerary items except this current selection
                    let updatedItineraryList = currentItineraryList.filter(
                        (item: any) => {
                            return item.int_id !== this.itineraryItem.int_id;
                        }
                    );

                    this.applicationService
                        .updateUserItinerarySelections({
                            selections: updatedItineraryList,
                        })
                        .subscribe(response => {
                            // update the list in local storage
                            //
                            if (response.success === true) {
                                localStorage.setItem(
                                    this.USER_ID + '-itinerarySelections',
                                    JSON.stringify(updatedItineraryList)
                                );

                                // set the new list as list next state
                                this.store.dispatch(
                                    ItineraryActions.setItineraryList({
                                        itineraryList: updatedItineraryList.map(
                                            (itineraryItem: any) => {
                                                return { ...itineraryItem };
                                            }
                                        ),
                                    })
                                );

                                this.sendEventActionsService.sendEventActions({
                                    pageview: '/remove-from-itinerary',
                                    eventAction: 'removeFromItinerary',
                                    eventCategory: 'Itinerary',
                                    ddAction: 'removeFromItinerary',
                                });
                            } else {
                                this.warning.create(response.message);
                            }
                        });
                }
            });
    }
    updateDate() {
        this.programService
            .availableDates(this.itineraryItem.programid)
            .subscribe(async (response: any) => {
                this.rows = response;
                await this.select.open();
            });
    }

    goToProgram(id) {
        this.navCtrl.navigateRoot(['/program/' + id]);
    }

    changeDates(event: any) {
        event.preventDefault();

        if (event.detail.value) {
            // get current list from local storage
            let itineraryListString = localStorage.getItem(
                this.USER_ID + '-itinerarySelections'
            );
            if (itineraryListString) {
                let currentItineraryList = JSON.parse(itineraryListString);
                // filter out all itinerary items except this current selection
                let oldItineraryItem = currentItineraryList.find(
                    (item: any) => {
                        return item.int_id === this.itineraryItem.int_id;
                    }
                );
                //

                let selectedDate = event.detail.value;

                var vals = selectedDate.startdate.split('-');

                let month = vals[0];
                let startyear = vals[2];

                let startdate = selectedDate.startdate;
                let enddate = selectedDate.enddate;
                //
                let newItineraryItem = {
                    ...oldItineraryItem,
                    startdate: startdate,
                    month: month,
                    startyear: startyear,
                    enddate: enddate,
                    saved_selected_date: { ...event.detail.value },
                };
                let index = currentItineraryList.findIndex((item: any) => {
                    return item.int_id === this.itineraryItem.int_id;
                });

                const originalItineraryList = [...currentItineraryList];
                //
                currentItineraryList.splice(index, 1, newItineraryItem);
                //
                let updatedItineraryList = currentItineraryList.map(
                    (itineraryItem: any) => {
                        return { ...itineraryItem };
                    }
                );

                this.applicationService
                    .userValidateItinerarySelection({
                        existingitinerarylist: originalItineraryList,
                        currentselection: newItineraryItem,
                    })
                    .subscribe(
                        (response: any) => {
                            if (response.success === true) {
                                // sort by start date descending order
                                updatedItineraryList = updatedItineraryList.sort(
                                    (a: any, b: any) =>
                                        new Date(a.startdate).getTime() -
                                        new Date(b.startdate).getTime()
                                );

                                localStorage.setItem(
                                    this.USER_ID + '-itinerarySelections',
                                    JSON.stringify(updatedItineraryList)
                                );
                                // set the new list as list next state
                                this.store.dispatch(
                                    ItineraryActions.setItineraryList({
                                        itineraryList: updatedItineraryList.map(
                                            (itineraryItem: any) => {
                                                return { ...itineraryItem };
                                            }
                                        ),
                                    })
                                );
                            } else {
                                this.warning.create(response.message);
                            }
                        },
                        err => {
                            if (err.error) {
                                err = err.error;
                                this.warning.create(err.message);
                            } else {
                                this.warning.create(err.message);
                            }
                        }
                    );
            } else {
                this.warning.create(
                    "We're sorry, we could not find your itinerary list at the moment. Create a new one."
                );
            }
        }
    }
}
